<template>
    <div>
        <div v-if="excelUrl" class="flex justify-end mb-1">
            <div class="btn bg-excel text-white" @click="downloadExcel()">Excel</div>
        </div>
        <m-basetable :count="count" :page="page" :rows="rows" :data="filter" :loading="loading" @refresh="clickRefresh"
                     @click="(row, index) => this.$emit('click', row, index)" :showRefresh="!local" :rowBind="rowBind">
            <template slot="header">
                <slot name="header"></slot>
            </template>
            <template v-slot="{row, index}">
                <slot :row="row" :index="index"></slot>
            </template>
            <template v-slot:extra="{row, index}">
                <slot name="extra" :row="row" :index="index"></slot>
            </template>
        </m-basetable>
    </div>
</template>
<script>
import Ajax from '@/js/ajax.js'
import BaseTable from './basetable.vue'

export default {
    components: {
        'm-basetable': BaseTable
    },
    name: 'm-table',
    props: {
        rowBind: Function,
        refresh: Function,
        args: Object,
        excelUrl: String,
        data: {
            type: Array,
            default: null
        },
        initial: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            // Page is always zero based
            page: 0,
            rows: 10,

            tabledata: [],
            count: 0,
            loading: this.refresh != null,
            // start index of data available
            dataStart: 0,
        }
    },
    watch: {
        args: {
            deep: true,
            handler() {
                // when refresing data jump to the first page 
                this.page = 0
                this.refreshData()
            }
        },
        data: {
            immediate: true,
            handler(val) {
                if (this.local && val) {
                    this.handleResponse({
                        data: val,
                        count: val.length
                    })
                }
            }
        }
    },
    mounted() {
        if (this.initial) {
            this.refreshData()
        } else {
            this.loading = false
        }
    },
    methods: {
        downloadExcel() {
            Ajax.download(this.excelUrl, this.args)
        },
        clickRefresh(page, rows) {
            this.page = page
            this.rows = rows
            this.refreshData()
        },
        rowClicked(row, index) {
            this.$emit('click', row, index)
        },
        labelCount() {
            var count = this.count || this.filter.length
            return `${this.start} - ${Math.min(this.end, count)} of ${count}`
        },
        refreshData() {
            if (!this.local) {
                this.loading = true
                if (typeof this.refresh != 'function') {
                    console.warn('Table refresh function not implemented')
                    return
                }
                var res = this.refresh(this.page, this.rows, this.args)
                if (res instanceof Promise) {
                    res.then(this.handleResponse)
                } else {
                    this.handleResponse(res)
                }
            }
        },
        handleResponse(resp) {
            if (!resp) {
                this.tabledata = []
                this.loading = false
                return
            }
            this.dataStart = this.page * this.rows
            this.count = resp.count
            if (resp.data && resp.data.length > 0) {
                this.tabledata = resp.data
            } else {
                // either null or empty array
                this.tabledata = []
            }
            this.loading = false
        }
    },
    computed: {
        local() {
            // Local is true when data refresh function is passed
            return this.refresh == null
        },
        filter() {
            if (!this.tabledata || this.tabledata.length == 0) {
                return []
            }
            if (this.local) {
                return this.tabledata.slice(this.page * this.rows, (this.page * this.rows) + this.rows)
            }
            return this.tabledata
        }
    }
}
</script>